import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import Resume from 'views/reports/balanceUsers/resume'; // Importing the Resume component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for recording balance users.
 * @extends JetView
 */
export default class recordBalanceUsersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme from app configuration
        const screen = this.app.config.size; // Current screen size from app configuration

        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying the theme to the toolbar
                    elements: [
                        { view: 'label', label: _('Resumen Financiero') }, // Label with localized text
                    ],
                },
                Resume, // Including the Resume component in the layout
            ],
        };

        return {
            type: 'wide', // Setting the type of the layout
            cols: [left], // Defining the columns of the layout
        };
    }
}

// FILE DOCUMENTED
